import { Check, Minus, TriangleAlert, X } from "lucide-react";

import type { GuardGauge } from "@/lib/integrations/guards";
import type { Tone } from "@/lib/integrations/words";

import styles from "./integrations.module.css";

function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

const TONE: Record<Tone, string> = {
  good: styles.gaugeGood,
  warning: styles.gaugeWarning,
  danger: styles.gaugeDanger,
  info: styles.gaugeGood,
  neutral: styles.gaugeNeutral,
};

function Glyph({ gauge }: { gauge: GuardGauge }) {
  if (gauge.off) return <Minus size={13} aria-label="off" />;
  if (gauge.tone === "danger") return <X size={13} aria-label="tripped" />;
  if (gauge.tone === "warning") return <TriangleAlert size={12} aria-label="close to the limit" />;
  if (gauge.tone === "good") return <Check size={13} aria-label="inside the limit" />;
  return <Minus size={13} aria-label="nothing to measure" />;
}

/** Each guard's value on a track, a mark where it pauses, and what happens if it trips. */
export function GuardGauges({ gauges }: { gauges: GuardGauge[] }) {
  return (
    <ul className={styles.gauges}>
      {gauges.map((gauge) => (
        <li key={gauge.key} className={cx(styles.gauge, TONE[gauge.tone])}>
          <div className={styles.gaugeHead}>
            <span className={styles.gaugeIcon}>
              <Glyph gauge={gauge} />
            </span>
            <span className={styles.gaugeLabel}>{gauge.label}</span>
            <strong className={styles.gaugeValue}>{gauge.valueText}</strong>
          </div>
          <div className={styles.gaugeTrack} aria-hidden>
            <span className={styles.gaugeFill} style={{ width: `${gauge.fill * 100}%` }} />
            {!gauge.off && <span className={styles.gaugeMark} style={{ left: `${gauge.mark * 100}%` }} />}
          </div>
          <span className={styles.gaugeNote}>
            {gauge.off
              ? "This guard is off."
              : `${gauge.limitText.charAt(0).toUpperCase()}${gauge.limitText.slice(1)}. ${gauge.tripped ? "Tripped: " : "If it trips: "}${gauge.ifTrips.charAt(0).toLowerCase()}${gauge.ifTrips.slice(1)}`}
          </span>
        </li>
      ))}
    </ul>
  );
}
